//import to reducer from action
import { SESSION_TOTAL_SESSLIST } from "SessionanalyticSesslistAction";

export const SessionAnalyticTotalSessListCnt = (state = {}, action) => {
  
    switch (action.type) {
      case SESSION_TOTAL_SESSLIST:
        return action.payload;
        break;
      default:
        return state;
        break;
    }
}